import { parse } from '@tock/query-string';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * takes the current location from react-router, and
 * parses the search values. accepts a type parameter of
 * the potential query string params and returns as that type
 * as used by the parse function of query-string.
 */
export function useQueryStringParams<P = {}>() {
  const location = useLocation();

  const queryStringParams = useMemo(() => parse<P>(location.search), [location.search]);
  return queryStringParams;
}
